/** React Currency Input integrated with unform */
import React, { useEffect, useRef, useState, Fragment } from "react";

import { useField } from "@rocketseat/unform";

import CurrencyInput from "react-currency-input";

export default function InputMask({
  name,
  onChangeEvent,
  innitialValue,
  value,
  ...props
}) {
  const { fieldName, registerField, error } = useField(name);
  const ref = useRef();
  const [fieldValue, setFieldValue] = useState(0);
  const [firstLoad, setFirstLoad] = useState(false);

  useEffect(() => {
    if (!firstLoad) {
      setFieldValue(innitialValue);
      setFirstLoad(true);
    } else {
      setFieldValue(value);
    }

    registerField({
      name: fieldName,
      ref: ref.current,
      path: "props.value",
      clearValue: pickerRef => {
        console.log(pickerRef);
      }
    });
    // eslint-disable-next-line prettier/prettier
  }, [ref.current, fieldName, value]); // eslint-disable-line

  function handleChange(event, maskedValue, floatValue) {
    const value = floatValue;

    if (onChangeEvent) {
      onChangeEvent(value);
    }

    setFieldValue(floatValue);
  }

  return (
    <Fragment>
      <CurrencyInput
        decimalSeparator=","
        thousandSeparator="."
        prefix="R$ "
        onChangeEvent={handleChange}
        value={fieldValue}
        name={name}
        ref={ref}
        {...props}
      />
      {error ? <span>{error}</span> : null}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/CurrencyField/InputMask/index.js